// extracted by mini-css-extract-plugin
module.exports = {"separator":"decision_separator-module__separator--2b2xA"};